<template>
  <div
    :id="content.idHTML"
    class="entete-page position-relative"
    :class="[jel_getClassObject(content), content.theme ? content.theme : 'themeClair']"
    :style="{
      '--couleurEntete': content.couleurEntete,
      '--couleurEnteteDebut': content.couleurEnteteDebut,
    }"
  >
    <div :class="content.imagePleineLargeur === 'true' ? 'contenu-pleine-largeur' : 'contenu'">
      <div
        class="position-relative m-auto"
        :class="[
          { 'image-pleine-largeur': content.imagePleineLargeur === 'true' },
          gradiantType,
          { 'texte-droite': content.alignementTexte === 'droite' },
        ]"
      >
        <MediaVideo v-if="content.videoLien" :content="contentMediaVideo" />
        <MediaImageFocalPoint v-else :content="contentMediaImage" :class="alignementImage" />
        <b-row
          class="m-auto restreindre-largeur"
          :class="{
            'justify-content-sm-end': content.alignementTexte === 'droite',
          }"
        >
          <div class="texte-information px-2 px-sm-3 px-xl-4 position-absolute">
            <Titre :content="contentSurTitre" />
            <p class="titre-entete p-0 mb-1 mr-0" v-html="content.titre" />
            <div
              v-if="content.sousTitre"
              class="sous-titre pt-0 pt-xl-1"
              v-html="content.sousTitre"
            />
            <b-row>
              <b-col :cols="content.texteAdditionnel ? 8 : 12">
                <span @click.capture="gaPreventClick">
                  <Hyperlien
                    :content="contentBouton"
                    class="pt-2 pb-3 pb-sm-4"
                    :class="{ themeAccent: content.boutonAccent == 'true' }"
                  />
                </span>
              </b-col>
              <b-col><div v-html="content.texteAdditionnel" /></b-col>
            </b-row>
          </div>
        </b-row>
      </div>
    </div>
    <div v-if="$mq == 'xs'" class="degrade position-absolute w-100 h-100" />
  </div>
</template>

<script>
import Titre from '@/components/base/Titre';
import Hyperlien from '@/components/base/Hyperlien';
import MediaImageFocalPoint from '@/components/media/image/MediaImageFocalPoint';
import MediaVideo from '@/components/bingo/media/MediaVideo';

import { gtmCustomEventByVendor } from '@/helpers/ConsentHelpers';

export default {
  name: 'EntetePage',
  components: {
    Titre,
    Hyperlien,
    MediaImageFocalPoint,
    MediaVideo,
  },
  props: { content: { type: Object, required: true } },
  computed: {
    contentMediaImage() {
      return {
        formatRatio: this.content.formatRatio ? this.content.formatRatio : '16x9',
        image: this.content.image,
      };
    },
    contentMediaVideo() {
      return {
        videoLien: this.content.videoLien,
        autoplay: this.content.autoplay,
        bgImage: this.content.image,
      };
    },
    contentSurTitre() {
      return {
        type: 'grandTitre',
        titre: this.content.surTitre,
        classeCSS: this.content.cacherSurTitre == 'true' ? 'sr-only' : 'p-0',
      };
    },
    contentBouton() {
      const theme = this.content.boutonAccent == 'true' ? 'boutonPrimaire' : 'boutonSecondaire';
      return {
        texte: this.content.libBouton,
        type: theme,
        lien: this.content.lien,
      };
    },
    alignementImage() {
      let format = `${this.content.formatRatio == '4x3' ? 'quatre-trois' : ''}`;
      if (this.content.alignementImage == 'left' || this.content.alignementImage == 'right') {
        format += ` align-${this.content.alignementImage}`;
      }
      return format;
    },
    gradiantType() {
      return `${this.content.videoLien ? 'vid' : 'img'}-gradient`;
    },
  },
  methods: {
    gaPreventClick(event = null) {
      const evt = 'ga-ep-click';
      const currentPath = window.location.pathname;
      let categorie = 'EP - Entete Page';
      const emplacement = this.jel_gaGetEmplacement();

      const libelle = this.jel_libelleLienGoogleAnalytics(this.content.lien);

      // Les entêtes de page dans la section promotion doivent avoir une autre categorie pour Google Analytics
      if (/fr\/promotion/i.test(currentPath) || /en\/promotion/i.test(currentPath)) {
        categorie = 'Promotions - EP';
      }

      // Ajout datalayer pour ajouter Event click sur bouton Image vers Google Analytics
      if (libelle) {
        gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
          event: evt,
          categorie,
          emplacement,
          libelle,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.entete-page {
  background-color: var(--couleurEnteteDebut);
}
.img-gradient {
  max-width: 1600px;
}
.texte-information ::v-deep {
  h1 {
    font-size: $font-size-4;
    line-height: $line-height-4;
    font-family: graphik_medium;
    margin-bottom: 0.25rem;
    width: 60%;
  }
}

.image-pleine-largeur {
  max-width: unset;
  ::v-deep img {
    object-fit: cover;
    object-position: center;
  }
}

.restreindre-largeur {
  .img-gradient.image-pleine-largeur {
    max-width: 1600px;
  }
}

.titre-entete {
  font-size: $font-size-12;
  line-height: $line-height-16;
  font-family: graphik_super;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-right: 24px;
  font-size: 1.75rem;
  line-height: 2rem;
}
.sous-titre {
  width: 80%;
  font-size: $font-size-6;
  line-height: $line-height-8;
  ::v-deep p {
    padding-bottom: 0;
    font-family: graphik_medium;
  }
}
::v-deep {
  .btn {
    margin-bottom: 0;
    font-size: $font-size-6;
    line-height: $line-height-5;
  }
  img {
    object-fit: cover;
    object-position: center;
    width: 100%;
  }
}

.degrade {
  bottom: 0;
}

.contenu {
  overflow: hidden;
  .image {
    max-width: 1600px;
    ::v-deep img {
      object-fit: contain;
      object-position: right;
    }
  }
}

.justify-content-start .restreindre-largeur {
  justify-content: flex-start !important;
}

.justify-content-center .restreindre-largeur {
  justify-content: center !important;
}

.justify-content-end .restreindre-largeur {
  justify-content: flex-end !important;
}

.contenu-pleine-largeur {
  overflow: hidden;
  .image {
    ::v-deep img {
      object-fit: cover;
      object-position: center;
    }
  }
  .img-gradient {
    ::v-deep img {
      object-fit: cover;
      object-position: center;
      position: relative;
      width: 100%;
      max-width: 1600px;
    }
  }
}

::v-deep a:not(.btn) {
  text-decoration: none;
  &:hover {
    border-bottom: none;
  }
}

.themeClair {
  ::v-deep a {
    color: $noir-casino;
    border-bottom: 2px solid $noir-casino;
  }
}

.themeFonce {
  ::v-deep a {
    color: $couleur-blanc;
    border-bottom: 2px solid white;
  }
}

@include media-breakpoint-down(xs) {
  .contenu {
    .img-gradient {
      > div:first-child {
        position: relative;
      }
      height: 450px;

      ::v-deep {
        img {
          margin: 0;
          height: 280px !important;
        }
        .align-left > img {
          object-position: left center;
        }
        .align-right > img {
          object-position: right center;
        }
      }
    }
    .texte-droite {
      ::v-deep {
        img {
          object-position: left center;
        }
      }
    }
  }
  .contenu-pleine-largeur {
    .img-gradient {
      > div:first-child {
        position: relative;
      }
      height: 450px;

      ::v-deep {
        img {
          object-position: right center;
          height: 280px !important;
        }
        .align-left > img {
          object-position: left center;
        }
        .align-right > img {
          object-position: right center;
        }
      }
    }
    .texte-droite {
      ::v-deep {
        img {
          object-position: left center;
        }
      }
    }
  }
  .texte-information {
    z-index: 1;
    bottom: 0;
  }
  .degrade {
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 30%, var(--couleurEntete) 62.5%);
  }
}

@include media-breakpoint-up(sm) {
  .contenu {
    height: auto;
    .img-gradient {
      height: 50vw;
      ::v-deep {
        img {
          object-fit: cover;
        }
        .align-left > img {
          object-position: left center;
        }
        .align-right > img {
          object-position: right center;
        }
        .quatre-trois > img {
          object-fit: contain;
        }
      }
    }
    .texte-information {
      -ms-transform: translateY(-60%);
      transform: translateY(-60%);
    }
  }
  .contenu-pleine-largeur {
    .img-gradient {
      height: 50vw !important;
      ::v-deep {
        .focal-point {
          height: 100%;
        }
        img {
          margin: 0 auto;
          object-fit: cover;
        }
        .align-left > img {
          object-position: left center;
          margin: 0 auto 0 0;
        }
        .align-right > img {
          object-position: right center;
          margin: 0 0 0 auto;
        }
      }
    }
    .texte-information {
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
    }
  }
  .texte-information {
    top: 55%;
    max-width: 48%;
    height: stretch;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .sous-titre {
    width: 80%;
    font-size: $font-size-5;
    line-height: $line-height-7;
  }
}
@include media-breakpoint-up(md) {
  .texte-information {
    max-width: 43%;
  }
  .contenu {
    height: 50vw;
    .img-gradient {
      margin-top: -3.5vw;
      margin-bottom: 2vw;
      height: 50vw !important;
    }
  }
  .titre-entete {
    font-size: $font-size-13;
    line-height: $line-height-18;
  }
  .sous-titre {
    font-size: $font-size-6;
    line-height: $line-height-8;
  }
}
@include media-breakpoint-up(lg) {
  .contenu {
    height: 45vw;
    .img-gradient {
      height: 45vw !important;
      ::v-deep {
        img {
          height: 45vw !important;
        }
        .align-left > img {
          margin: 0 auto 0 0;
        }
        .align-right > img {
          margin: 0 0 0 auto;
        }
        .quatre-trois > img {
          height: 45vw !important;
        }
      }
    }
    .texte-information {
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
    }
  }
  .contenu-pleine-largeur {
    .img-gradient {
      height: 45vw !important;
    }
  }
  .texte-information {
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
}
@include media-breakpoint-up(xl) {
  .contenu {
    height: 37.5vw !important;

    .img-gradient {
      height: 37.5vw !important;
      ::v-deep {
        img {
          height: 37.5vw !important;
        }
        .quatre-trois > img {
          width: 50vw !important;
        }
      }
    }
  }
  .contenu-pleine-largeur {
    .img-gradient {
      height: 37.5vw !important;
      ::v-deep {
        img {
          height: 37.5vw !important;
          margin: 0 auto !important;
        }
      }
    }
  }
  .texte-information {
    max-width: 42%;
  }
  .titre {
    font-size: $font-size-14;
    line-height: $line-height-20;
  }
  .titre-entete {
    font-size: $font-size-14;
    line-height: $line-height-20;
  }
}
@media screen and (min-width: 1600px) {
  .contenu {
    height: 650px !important;
    .img-gradient {
      height: 650px !important;
      ::v-deep {
        img {
          height: 650px !important;
        }
        .quatre-trois > img {
          height: 650px !important;
        }
      }
    }
  }
  .contenu-pleine-largeur {
    .img-gradient {
      height: 650px !important;
      ::v-deep {
        img {
          height: 650px !important;
        }
      }
    }
  }
  .texte-information {
    max-width: 500px;
  }
}
::v-deep {
  .grandTitre {
    font-size: 13px;
    line-height: 14px;

    @include media-breakpoint-up(sm) {
      font-size: 14px;
      line-height: 16px;
    }
  }
}
</style>
